import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ApplicationModel} from '../../../../../projects/api/src/applications/application.model';

@Component({
    selector: 'app-application-picker',
    templateUrl: './application-picker.component.html',
    styleUrls: ['./application-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ApplicationPickerComponent {
  @Input() applications: ApplicationModel[] = [];

  constructor() {
  }


}
